import TicketsList from './TicketsList'

export default TicketsList
